import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { DateTimeInput } from "../../../components/inputs";

const EditableCell = ({
  cell: { value: initialValue },
  row: { index },
  column: { id },
  updateData
}) => {
  const [value, setValue] = useState(initialValue);
  const handleChange = e => {
    setValue(e.target.value);
  };
  const handleBlur = () => {
    updateData({ value, index, id });
  };
  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  return (
    <DateTimeInput value={value} onBlur={handleBlur} onChange={handleChange} />
  );
};

EditableCell.propTypes = {
  cell: PropTypes.object,
  row: PropTypes.object,
  column: PropTypes.object,
  updateData: PropTypes.func
};

export default EditableCell;
